import logLevels from "./logLevels";
import { formatLogMessage } from "./logFormatter";
import logLevelTypes from "../../consts/logLevelTypes";

const logData = (level, message, error) => {
    try {
        if (!logLevels[level].enabled) return;

        const logFunction = logLevels[level].method;
        if (logFunction) {
            logFunction(formatLogMessage(level, message, error));
        }

    } catch (error) {
        console.error(error?.message || "Log error")
    }
}

const log = {
    info: (message) => logData(logLevelTypes.INFO, message),
    trace: (message) => logData(logLevelTypes.TRACE, message),
    warning: (message) => logData(logLevelTypes.WARNING, message),
    debug: (message) => logData(logLevelTypes.DEBUG, message),
    error: (message, error) => logData(logLevelTypes.ERROR, message, error),
}

export default log;